import { DataTableMultiSelectBar } from './DataTableMultiSelectBar';

export default DataTableMultiSelectBar;
